module.exports = new Promise(async (resolve, reject) => {
      try {
        const module = await import('https://sn2-care-journal-dev14.web.app/assets/remoteEntry.js?t=1746500546760');
        resolve(module);
      } catch (error) {
        // console.error('Failed to load remote:', error);
        resolve(null);
      }
    })
;